/** Shared field chrome for the dark forms drawer. */
export const fieldProps = {
  bg: "whiteAlpha.50",
  border: "1px solid",
  borderColor: "whiteAlpha.200",
  borderRadius: "12px",
  color: "white",
  fontSize: "14px",
  _placeholder: { color: "whiteAlpha.500" },
  _focus: { borderColor: "#817EFF", boxShadow: "none" },
};

export const invalidFieldProps = {
  borderColor: "#F87171",
  _focus: { borderColor: "#F87171", boxShadow: "none" },
};

export const ACCENT = "#817EFF";
export const DANGER = "#F87171";
export const SUCCESS = "#34D399";
